export default "__VITE_ASSET__bc703ef0__"